import "./PerpetualModeBanner.scss";
import { useLicenseSelector } from "userful-chronos-common-store/dist/license";
import { isLicenseInPerpetualMode } from "userful-chronos-app-common-js/dist/models/license/license";
import { useTranslation } from "react-i18next";

interface IProps {}

export default function PerpetualModeBanner(props: IProps) {
    const license = useLicenseSelector((state) => state.licenseStore.license);
    const perpetualMode = isLicenseInPerpetualMode(license);
    const { t } = useTranslation();
    if (!perpetualMode) {
        return null;
    }

    return <div className="perpetualModeBanner">{t("ConfigApp.LicenseDetails.perpetualModeBanner")}</div>;
}
